(() => {
  class TogglePassword extends HTMLElement {
    connectedCallback() {
      this.passwordInput = this.parentElement.querySelector("input[type='password']");
      this.eyeOpen = this.querySelector(".js-eye-open");
      this.eyeClosed = this.querySelector(".js-eye-close");
      this.bottom = "12px";

      if (this.nextElementSibling) {
        this.bottom = `${18 + 12}px`;
      }

      this.classList.add("toggle-password");
      this.style.bottom = this.bottom;

      if (!this.passwordInput) {
        throw new Error("No password input found");
      }

      this.addEventListener("click", this.togglePasswordVisibility.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.togglePasswordVisibility.bind(this));
    }

    togglePasswordVisibility() {
      if (this.passwordInput.type === "password") {
        this.passwordInput.type = "text";
        this.eyeOpen.classList.add("hidden");
        this.eyeClosed.classList.remove("hidden");
      } else {
        this.passwordInput.type = "password";
        this.eyeOpen.classList.remove("hidden");
        this.eyeClosed.classList.add("hidden");
      }
    }
  }

  if (!customElements.get("toggle-password")) {
    customElements.define("toggle-password", TogglePassword);
  }
})();
